export default __webpack_public_path__ + "static/media/college.84dde9fd.jpg";